import { rem } from "polished";
import styled from "styled-components";

import type { ImagePosition } from "@/components/editor/image-positioner/image-positioner-component";
import type { ImageFit } from "@/components/editor/shared/header/header-settings-component";
import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";

export const Wrapper = styled.div`
  position: relative;
`;

export const Container = withViewportStyle("div")`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  padding: ${rem(177)} ${rem(24)};
  min-height: ${rem(780)};

  ${(props) => props.$viewport.tablet`
    padding: ${rem(48)} ${rem(24)};
  `}

  ${(props) => props.$viewport.mobile`
    padding: ${rem(80)} ${rem(16)};
  `}

  .text-primitive, 
  .hazel .ck-content h1,
  .hazel .ck-content h2,
  .hazel .ck-content h3,
  .hazel .ck-content h4,
  .hazel .ck-content h5,
  .hazel .ck-content p,
  .hazel .ck-content li {
    color: #fff;
  }

  .ck-content h1,
  .ck-content h2,
  .ck-content h3,
  .ck-content h4,
  .ck-content h5,
  .ck-content p {
    margin: 0
  }
`;

export const Content = withViewportStyle("div")`
  display: grid;
  grid-row-gap: ${rem(24)};
  align-content: center;
  justify-content: center;
  max-width: ${rem(1064)};
  position: relative;
  text-align: center;

  ${(props) => props.$viewport.tablet`
    grid-row-gap: ${rem(40)};

    .text-primitive {
      text-align: center;
    }
  `}
`;

export const TextContent = withViewportStyle("div")`
  display: grid;
  grid-row-gap: ${rem(16)};
`;

export const ImageWrapper = withViewportStyle("div")`
  width: 100%;
  height: 100%;
  position: absolute;

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0,0,0,.7);
  }
`;

export const Image = withViewportStyle("img")<{
  $position: ImagePosition;
  imageFit?: ImageFit;
}>`
  width: 100%;
  height: 100%;
  object-fit: ${({ imageFit }) => imageFit || "cover"};
  object-position: ${(props) => props.$position};
  overflow: hidden;
`;

export const LogoWrapper = withViewportStyle("div")`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logo = withViewportStyle("img")<{ isLogoResized: boolean }>`
  max-height: ${({ isLogoResized }) => (isLogoResized ? rem(120) : rem(40))};
  max-width: 100%;
  object-fit: contain;

  ${(props) => props.$viewport.tablet`
    max-height: ${({ isLogoResized }) => (isLogoResized ? rem(100) : rem(35))};
  `}

  ${(props) => props.$viewport.mobile`
    max-height: ${({ isLogoResized }) => (isLogoResized ? rem(80) : rem(31))};
  `}
`;

export const CTATextWrapper = withViewportStyle("div")`
  background: rgba(255,255,255,.1);
  padding: ${rem(24)};
  margin: auto;

  ${(props) => props.$viewport.mobile`
    margin-bottom: ${rem(8)};
  `}
`;
